// Vendor imports
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const CirclePositioner = require('client-v2/common/components/circle-positioner')
const LazyImage = require('client-v2/common/components/lazy-image')
const Icon = require('client-v2/common/containers/icons/component')
const { userProfileHref } = require('client-v2/common/models/user/actions')
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('UserAvatar')

function UserAvatar(props) {
  const photoUrl = props.user['photo_url']
  let href = props.href
  if (props.href === true) {
    href = userProfileHref(props.user)
  }
  let badgeId
  if (props.badge !== false) {
    if (props.user.isVerifiedCurator) {
      badgeId = 'verified-curator'
    }
  }
  return (
    tag('div', {
      className: classNames(
        props.className,
        bem.block()
      ),
      style: props.style
    },
      tag(LazyImage, {
        className: bem.element('image'),
        href,
        sources: [ photoUrl ],
        visible: props.visible,
        onClick: props.onClick
      }),
      badgeId && (
        tag(CirclePositioner, {
          className: bem.element('badge-positioner')
        },
          tag(Icon, {
            className: bem.element('badge'),
            id: badgeId
          })
        )
      )
    )
  )
}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')

  UserAvatar.propTypes = {
    // Values
    badge: PropTypes.bool,
    className: PropTypes.string,
    href: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.string
    ]),
    user: PropTypes.shape({
      // Works for collections too!
      isVerifiedCurator: PropTypes.bool,
      'photo_url': PropTypes.string.isRequired,
      username: PropTypes.string.isRequired
    }),
    visible: PropTypes.bool,
    // Callbacks
    onClick: PropTypes.func
  }
}

module.exports = UserAvatar
